import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import icon from "../../assets/icon.png";

const OurServices = () => {
  const navigate = useNavigate();
  const [subservices, setSubservices] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  useEffect(() => {
    const fetchSubservices = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/subservices/get-all-subservices`);

        // Normalize response data
        const subservicesData = res.data?.data || [];

        setSubservices(subservicesData);
        setError(null);
      } catch (err) {
        console.error("Failed to fetch subservices:", err);
        setError("Unable to load subservices. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchSubservices();
  }, []);

  const displayedSubservices = showAll ? subservices : subservices.slice(0, 6);

  if (loading) {
    return (
      <div className="flex justify-center items-center py-20">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#2F9BD6]"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-20">
        <p className="text-xl text-red-500">{error}</p>
      </div>
    );
  }

  if (subservices.length === 0) {
    return (
      <div className="text-center py-20 text-gray-500">
        No subservices available at the moment.
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4 my-4 px-4 md:px-10">
      {/* Section Header */}
      <div className="flex items-center justify-center flex-col gap-2">
        <span
          data-aos="fade-down"
          className="border-b-2 font-semibold border-[#FF3131] py-2 tracking-wide text-center text-[#FF3131] my-2"
        >
          Our Services
        </span>
        <p
          data-aos="flip-right"
          className="lg:text-4xl md:text-3xl text-2xl tracking-wider font-bold"
        >
          Let’s See What <span className="text-[#2F9BD6]">We</span> Provide
        </p>
      </div>

      {/* Subservice Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-6">
        {displayedSubservices.map((sub, i) => {
          const imageUrl =
            sub?.images?.[0] && sub.images[0].trim() !== ""
              ? sub.images[0]
              : `https://via.placeholder.com/400x250/2F9BD6/FFFFFF?text=${encodeURIComponent(
                  sub?.subserviceName || "Subservice"
                )}`;

          return (
            <div
              key={sub._id}
              onClick={() => navigate(`/sub-service-details/${sub._id}`)}
              data-aos={i % 2 === 0 ? "zoom-in" : "flip-up"}
              className="flex justify-center items-center cursor-pointer"
            >
              <div className="relative w-full ">
                <img
                  src={imageUrl}
                  alt={sub?.subserviceName || "Subservice"}
                  className="w-full h-64 object-cover rounded-lg shadow-md"
                />
                <div className="absolute bottom-5 left-5 flex flex-col items-start gap-2 px-4">
                  <h2 className="text-xl font-bold text-[#a1880a] drop-shadow-lg">
                    {sub?.subserviceName || "Unnamed Subservice"}
                  </h2>
                  <img src={icon} alt="icon" className="w-6 h-6" />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* View All Button */}
      {subservices.length > 6 && (
        <div className="flex justify-center mt-8">
          <button
            onClick={() => setShowAll(!showAll)}
            className="bg-[#2F9BD6] text-white px-8 py-3 rounded-lg font-semibold hover:bg-[#1E85FC] transition-colors duration-300 shadow-lg"
          >
            {showAll ? "View Less" : `View All (${subservices.length - 6} more)`}
          </button>
        </div>
      )}
    </div>
  );
};

export default OurServices;
